import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import CountryService from "./CountryService";

export const getCategories = createAsyncThunk(
  "category/getAllCat",
  async (thunkAPI) => {
    try {
      return await CountryService.getNewsCategories();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createNewNewsCat = createAsyncThunk(
  "category/addCategory",
  async (catData, thunkAPI) => {
    try {
      return await CountryService.createNewsCategory(catData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getANewsCatt = createAsyncThunk(
  "category/getCat",
  async (id, thunkAPI) => {
    try {
      return await CountryService.getNewsCategory(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateANewsCat = createAsyncThunk(
  "category/editCategory",
  async (NewsCat, thunkAPI) => {
    try {
      return await CountryService.updateNewsCategory(NewsCat);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteANewsCat = createAsyncThunk(
  "category/deleteCategory",
  async (id, thunkAPI) => {
    try {
      return await CountryService.deleteNewsCategory(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");
const initialState = {
  bCategories: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const pCategorySlice = createSlice({
  name: "bCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.bCategories = action.payload.data;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createNewNewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNewNewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createNewsCategory = action.payload;
      })
      .addCase(createNewNewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getANewsCatt.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getANewsCatt.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.countryName = action.payload.data.countryName;
        state.description = action.payload.data.description;
        state.link = action.payload.data.link;
        state.type = action.payload.data.type;
        
      })
      .addCase(getANewsCatt.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedNewsCategory = action.payload;
      })
      .addCase(updateANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedNewsCategory = action.payload;
      })
      .addCase(deleteANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default pCategorySlice.reducer;
